import { Component, OnInit, ViewChild } from '@angular/core';
import { BaliseService } from 'src/app/data/edition/services/balise/balise.service';
import { DocumentService } from 'src/app/data/edition/services/document/document.service';
import { Document } from 'src/app/data/edition/models/document.model';
import { forkJoin } from 'rxjs';
import { SessionContext } from 'src/app/core/services/config/app.settings';
import { ReferencesEditionService } from 'src/app/data/edition/services/references-edition/references-edition.service';
import { TypeBaliseEnum } from 'src/app/data/edition/models/enums/type-balise.enum.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Balise } from 'src/app/data/edition/models/balise.model';
import { ReferencesEdition } from 'src/app/data/edition/models/references-edition.model';
import { RefCategorie } from 'src/app/data/edition/models/ref-categorie.model';
import { RefTypeBalise } from 'src/app/data/edition/models/ref-type-balise.model';
import { CategorieEnum } from 'src/app/data/edition/models/enums/categorie.enum.model';
import { AddDocumentComponent } from '../../modals/add-document/add-document.component';
import { ReferentielService } from 'src/app/data/declaration/services/referentiel/referentiel.service';
import { RefMouvement } from 'src/app/data/declaration/models/ref-mouvement.model';
import { LoaderService } from '../../../../../core/services/loader/loader.service';
import { TreeNode } from 'primeng/api';

@Component({
    selector: 'app-gestion-templates',
    templateUrl: './gestion-templates.component.html',
    styleUrls: ['./gestion-templates.component.scss'],
    standalone: false
})
export class GestionTemplatesComponent implements OnInit {
    constructor(
        private readonly baliseService: BaliseService,
        private readonly documentService: DocumentService,
        private readonly loaderService: LoaderService,
        private readonly referentielService: ReferentielService,
        private readonly referencesEditionService: ReferencesEditionService,
        private readonly modalService: NgbModal,
        private readonly toastr: ToastrService,
        private readonly translate: TranslateService
    ) {
        this.showHelp = false;
    }
    references: ReferencesEdition;
    categories: RefCategorie[];
    typesBalises: RefTypeBalise[];
    selectedCategorie: RefCategorie;
    selectedDocument: Document;

    mouvements: RefMouvement[];

    balises: Balise[] = [];
    allDocuments: Document[] = [];
    documents: Document[] = [];
    tinyMceConfig: any;
    tinymce: any;
    loaded = false;

    balisesCommun: Balise[];
    balisesCommission: Balise[];
    balisesControle: Balise[];
    balisesEchantillon: Balise[];
    balisesDeclaration: Balise[];
    balisesTournee: Balise[];
    balisesManquement: Balise[];

    nodeBaliseCommun: Balise = new Balise();
    nodeBaliseCommission: Balise = new Balise();
    nodeBaliseEchantillon: Balise = new Balise();
    nodeBaliseControle: Balise = new Balise();
    nodeBaliseDeclaration: Balise = new Balise();
    nodeBaliseTournee: Balise = new Balise();
    nodeBaliseManquement: Balise = new Balise();

    disableEditor = false;
    showHelp: boolean;

    firstLoad = false;

    nodes: TreeNode[] = [];

   
    changeCategorie() {
        this.documents = this.allDocuments.filter(d => d.refCategorie.id === this.selectedCategorie.id);

        switch (this.selectedCategorie.code) {
            case CategorieEnum.COMMUN:
                this.nodes = this.mapBaliseToPrimeTree(this.nodeBaliseCommun);
                break;
            case CategorieEnum.COMMISSION:
                this.nodes = this.mapBaliseToPrimeTree(this.nodeBaliseCommission);
                break;
            case CategorieEnum.ECHANTILLON:
                this.nodes = this.mapBaliseToPrimeTree(this.nodeBaliseEchantillon);
                break;
            case CategorieEnum.CONTROLE:
                this.nodes = this.mapBaliseToPrimeTree(this.nodeBaliseControle);
                break;
            case CategorieEnum.DECLARATION:
                this.nodes = this.mapBaliseToPrimeTree(this.nodeBaliseDeclaration);
                break;
            case CategorieEnum.TOURNEE:
                this.nodes = this.mapBaliseToPrimeTree(this.nodeBaliseTournee);
                break;
            case CategorieEnum.MANQUEMENT:
                this.nodes = this.mapBaliseToPrimeTree(this.nodeBaliseManquement);
                break;
        }

        this.selectedDocument = null;
        this.firstLoad = true;
        if (this.tinymce) {
            this.tinymce.setContent('');
        }
    }

    ngOnInit() {
        this.selectedCategorie = null;
        forkJoin(
            this.referencesEditionService.getReferences(),
            this.referentielService.getReferentiel(),
            this.baliseService.getBalises(),
            this.documentService.getDocuments(SessionContext.get('idOrganisme'))
        )
            .pipe(this.loaderService.operator())
            .subscribe(([ref, referentiel, balises, documents]) => {
                this.balises = balises;
                this.mouvements = referentiel.refMouvements;
                this.allDocuments = documents;
                this.allDocuments.forEach(doc => {
                    if (doc.idRefMouvement !== null) {
                        doc.mouvement = this.mouvements.find(mvt => mvt.id === doc.idRefMouvement);
                    }
                });
                this.categories = ref.refCategorieList.filter(refCategorie => refCategorie.code !== CategorieEnum.ORGANISME);
                this.typesBalises = ref.refTypeBaliseList;
                this.balisesCommun = this.balises.filter(b => b.refCategorie.code === CategorieEnum.COMMUN);
                this.balisesCommission = this.balises.filter(b => b.refCategorie.code === CategorieEnum.COMMISSION);
                this.balisesControle = this.balises.filter(b => b.refCategorie.code === CategorieEnum.CONTROLE);
                this.balisesEchantillon = this.balises.filter(b => b.refCategorie.code === CategorieEnum.ECHANTILLON);
                this.balisesDeclaration = this.balises.filter(b => b.refCategorie.code === CategorieEnum.DECLARATION);
                this.balisesTournee = this.balises.filter(b => b.refCategorie.code === CategorieEnum.TOURNEE);
                this.balisesManquement = this.balises.filter(b => b.refCategorie.code === CategorieEnum.MANQUEMENT);

                this.nodeBaliseCommun = this.remplirArbre(CategorieEnum.COMMUN);
                this.nodeBaliseCommission = this.remplirArbre(CategorieEnum.COMMISSION);
                this.nodeBaliseControle = this.remplirArbre(CategorieEnum.CONTROLE);
                this.nodeBaliseEchantillon = this.remplirArbre(CategorieEnum.ECHANTILLON);
                this.nodeBaliseDeclaration = this.remplirArbre(CategorieEnum.DECLARATION);
                this.nodeBaliseTournee = this.remplirArbre(CategorieEnum.TOURNEE);
                this.nodeBaliseManquement = this.remplirArbre(CategorieEnum.MANQUEMENT);

                this.loaded = true;
            });

        this.tinyMceConfig = {
            height: 600,
            menubar: false,
            plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'searchreplace',
                'visualblocks',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'table',
                'help',
                'wordcount',
                'pagebreak'
                // 'advcode' → plugin premium, à garder seulement si licence Tiny Cloud
            ],
            toolbar:
                'undo redo | ' +
                'blocks fontfamily fontsize | ' +
                'lineheight | ' +
                'bold underline italic forecolor backcolor | ' +
                'table | ' +
                'alignleft aligncenter alignright alignjustify | ' +
                'pagebreak | ' +
                'bullist numlist outdent indent | ' +
                'removeformat | image | code | help',

            language: 'fr_FR',
            table_header_type: 'sectionCells',

            font_size_formats: '7pt 8pt 10pt 12pt 14pt 18pt 24pt 36pt',
            lineheight_formats: '0.5 0.8 1 1.1 1.2 1.3 1.4 1.5 2',
            pagebreak_separator: '<br><div style="page-break-after:always;"></div>',

            setup: tinymce => {
                this.tinymce = tinymce;
            }
        };
    }

    mapBaliseToPrimeTree(root: Balise): TreeNode[] {
        if (!root) return [];
        return [this.toTreeNode(root, true)];
    }

    private toTreeNode(b: Balise, expanded = false): TreeNode {
        const isNested = b?.refTypeBalise?.code === TypeBaliseEnum.NESTED;

        return {
            key: String(b.id),
            label: b.libelle,
            data: b,
            expanded,
            children: (b.childrens ?? []).map(child => this.toTreeNode(child, false))
        };
    }

    remplirArbre(categorie: CategorieEnum): Balise {
        let baliseReturn: Balise = new Balise();
        let balisesCategorie: Balise[] = [];

        switch (categorie) {
            case CategorieEnum.COMMUN:
                balisesCategorie = this.balisesCommun;
                break;
            case CategorieEnum.COMMISSION:
                balisesCategorie = this.balisesCommission;
                break;
            case CategorieEnum.ECHANTILLON:
                balisesCategorie = this.balisesEchantillon;
                break;
            case CategorieEnum.CONTROLE:
                balisesCategorie = this.balisesControle;
                break;
            case CategorieEnum.DECLARATION:
                balisesCategorie = this.balisesDeclaration;
                break;
            case CategorieEnum.TOURNEE:
                balisesCategorie = this.balisesTournee;
                break;
            case CategorieEnum.MANQUEMENT:
                balisesCategorie = this.balisesManquement;
                break;
        }

        balisesCategorie.forEach(balise => {
            if (!balise.idBaliseParent && balise.refTypeBalise.code === TypeBaliseEnum.NESTED) {
                baliseReturn = balise;
                baliseReturn.childrens = [];
                const childrens: Balise[] = balisesCategorie.filter(b => b.idBaliseParent === baliseReturn.id);
                baliseReturn.childrens = childrens;

                baliseReturn.childrens.forEach(premierNiveau => {
                    if (premierNiveau.refTypeBalise.code === TypeBaliseEnum.NESTED) {
                        premierNiveau.childrens = [];
                        const childrens: Balise[] = balisesCategorie.filter(b => b.idBaliseParent === premierNiveau.id);
                        premierNiveau.childrens = childrens;

                        premierNiveau.childrens.forEach(deuxiemeNiveau => {
                            if (deuxiemeNiveau.refTypeBalise.code === TypeBaliseEnum.NESTED) {
                                deuxiemeNiveau.childrens = [];
                                const childrens: Balise[] = balisesCategorie.filter(b => b.idBaliseParent === deuxiemeNiveau.id);
                                deuxiemeNiveau.childrens = childrens;

                                deuxiemeNiveau.childrens.forEach(troisiemeNiveau => {
                                    if (troisiemeNiveau.refTypeBalise.code === TypeBaliseEnum.NESTED) {
                                        troisiemeNiveau.childrens = [];
                                        const childrens: Balise[] = balisesCategorie.filter(b => b.idBaliseParent === troisiemeNiveau.id);
                                        troisiemeNiveau.childrens = childrens;

                                        troisiemeNiveau.childrens.forEach(quatriemeNiveau => {
                                            if (quatriemeNiveau.refTypeBalise.code === TypeBaliseEnum.NESTED) {
                                                quatriemeNiveau.childrens = [];
                                                const childrens: Balise[] = balisesCategorie.filter(b => b.idBaliseParent === quatriemeNiveau.id);
                                                quatriemeNiveau.childrens = childrens;
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });
        return baliseReturn;
    }

    mapBaliseToTreeComponentObjet(balise: Balise): any {
        const nodes = [];

        let balisesCategorie: Balise[] = [];

        switch (this.selectedCategorie.code) {
            case CategorieEnum.COMMUN:
                balisesCategorie = this.balisesCommun;
                break;
            case CategorieEnum.COMMISSION:
                balisesCategorie = this.balisesCommission;
                break;
            case CategorieEnum.ECHANTILLON:
                balisesCategorie = this.balisesEchantillon;
                break;
            case CategorieEnum.CONTROLE:
                balisesCategorie = this.balisesControle;
                break;
            case CategorieEnum.DECLARATION:
                balisesCategorie = this.balisesDeclaration;
                break;
            case CategorieEnum.TOURNEE:
                balisesCategorie = this.balisesTournee;
                break;
            case CategorieEnum.MANQUEMENT:
                balisesCategorie = this.balisesManquement;
                break;
        }

        nodes.push({
            id: balise.id,
            code: balise.code,
            name: balise.libelle,
            codeTypeBalise: balise.refTypeBalise.code,
            idBaliseParent: balise.idBaliseParent,
            children: []
        });

        const childrenPremierNiveau = [];
        balise.childrens.forEach(c => {
            if (c.refTypeBalise.code === TypeBaliseEnum.NESTED) {
                childrenPremierNiveau.push({
                    id: c.id,
                    code: c.code,
                    name: c.libelle,
                    codeTypeBalise: c.refTypeBalise.code,
                    idBaliseParent: balise.idBaliseParent,
                    children: []
                });
            } else {
                childrenPremierNiveau.push({
                    id: c.id,
                    code: c.code,
                    name: c.libelle,
                    codeTypeBalise: c.refTypeBalise.code,
                    idBaliseParent: balise.idBaliseParent
                });
            }
            nodes[0].children = childrenPremierNiveau;
        });
        nodes[0].children.forEach(element => {
            if (element.codeTypeBalise === TypeBaliseEnum.NESTED) {
                const childrenDeuxiemeNiveau = [];
                const balisesByParent: Balise[] = balisesCategorie.filter(b => b.idBaliseParent === element.id);
                balisesByParent.forEach(bbp => {
                    childrenDeuxiemeNiveau.push({
                        id: bbp.id,
                        code: bbp.code,
                        name: bbp.libelle,
                        codeTypeBalise: bbp.refTypeBalise.code,
                        idBaliseParent: bbp.idBaliseParent,
                        children: []
                    });
                });
                element.children = childrenDeuxiemeNiveau;
            }

            if (element.codeTypeBalise === TypeBaliseEnum.NESTED) {
                element.children.forEach(element => {
                    if (element.codeTypeBalise === TypeBaliseEnum.NESTED) {
                        const childrenTroisiemeNiveau = [];
                        const balisesByParent: Balise[] = balisesCategorie.filter(b => b.idBaliseParent === element.id);
                        balisesByParent.forEach(bbp => {
                            childrenTroisiemeNiveau.push({
                                id: bbp.id,
                                code: bbp.code,
                                name: bbp.libelle,
                                codeTypeBalise: bbp.refTypeBalise.code,
                                idBaliseParent: bbp.idBaliseParent,
                                children: []
                            });
                        });
                        element.children = childrenTroisiemeNiveau;
                    }
                });
            }

            if (element.codeTypeBalise === TypeBaliseEnum.NESTED) {
                element.children.forEach(element => {
                    element.children.forEach(element => {
                        if (element.codeTypeBalise === TypeBaliseEnum.NESTED) {
                            const childrenQuatriemeNiveau = [];
                            const balisesByParent: Balise[] = balisesCategorie.filter(b => b.idBaliseParent === element.id);
                            balisesByParent.forEach(bbp => {
                                childrenQuatriemeNiveau.push({
                                    id: bbp.id,
                                    code: bbp.code,
                                    name: bbp.libelle,
                                    codeTypeBalise: bbp.refTypeBalise.code,
                                    idBaliseParent: bbp.idBaliseParent,
                                    children: []
                                });
                            });
                            element.children = childrenQuatriemeNiveau;
                        }
                    });
                });
            }
        });
        return nodes;
    }

    onActivate($event) {
        this.tinymce.insertContent(this.getHtmlByBaliseCode($event.node.data.code));
    }

    onNodeSelect(event: any) {
        const balise: Balise = event.node.data;
        this.tinymce.insertContent(this.getHtmlByBaliseCode(balise.code));
    }

    getHtmlByBaliseCode(code: string): string {
        return this.balises.find(balise => balise.code === code).html;
    }

    addNewDocument() {
        const modalRef = this.modalService.open(AddDocumentComponent, { size: 'lg', backdrop: 'static' });
        modalRef.result.then(result => {
            if (result) {
                const document: Document = new Document();
                document.libelle = result;
                document.refCategorie = this.selectedCategorie;
                document.isIndividuel = false;
                document.isMailable = false;
                document.isPaysage = false;
                document.template = '';
                document.idOrganisme = SessionContext.get('idOrganisme');

                this.documentService.createDocument(SessionContext.get('idOrganisme'), document).subscribe(response => {
                    this.toastr.success(
                        this.translate.instant('page.edition.gestion-templates.creation-reussie'),
                        this.translate.instant('page.edition.gestion-templates.nouveau-document'),
                        { timeOut: 10 * 1000 }
                    );
                    this.documentService.getDocumentsByCategorie(this.selectedCategorie.id, SessionContext.get('idOrganisme')).subscribe(documents => {
                        this.documents = documents;
                        this.selectedDocument = this.documents.find(d => d.id === response.id);
                        if (this.firstLoad) {
                            setTimeout(() => {
                                this.tinymce.setContent('');
                                this.firstLoad = false;
                            }, 3000);
                        } else {
                            this.tinymce.setContent('');
                        }
                    });
                });
            }
        });
    }

    save() {
        if (this.selectedDocument.idOrganisme) {
            const document: Document = new Document();
            document.libelle = this.selectedDocument.libelle;
            document.id = this.selectedDocument.id;
            document.refCategorie = this.selectedCategorie;
            document.isIndividuel = this.selectedDocument.isIndividuel;
            document.isPaysage = this.selectedDocument.isPaysage;
            document.isMailable = false;
            document.idOrganisme = SessionContext.get('idOrganisme');
            document.template = this.getContentEditor();
            document.isEntete = this.selectedDocument.isEntete;
            if (this.selectedCategorie.code === 'DECLARATION') {
                document.useByOperateur = this.selectedDocument.useByOperateur;
                document.idRefMouvement =
                    this.selectedDocument && this.selectedDocument.mouvement ? this.selectedDocument.mouvement.id : this.selectedDocument.idRefMouvement;
            }

            this.documentService.modifyDocument(SessionContext.get('idOrganisme'), document).subscribe(() => {
                this.toastr.success(this.translate.instant('page.edition.gestion-templates.modification-reussie'), this.translate.instant(document.libelle), {
                    timeOut: 10 * 1000
                });

                this.documentService.getDocumentsByCategorie(this.selectedCategorie.id, SessionContext.get('idOrganisme')).subscribe(documents => {
                    this.documents = documents;
                    this.selectedDocument = this.documents.find(d => d.id === document.id);
                    this.selectedDocument.mouvement = this.mouvements.find(mvt => mvt.id === document.idRefMouvement);
                });
            });
        } else {
            const document: Document = new Document();
            document.libelle = this.selectedDocument.libelle;
            document.refCategorie = this.selectedCategorie;
            document.isIndividuel = this.selectedDocument.isIndividuel;
            document.isPaysage = this.selectedDocument.isPaysage;
            document.isMailable = false;
            document.idOrganisme = SessionContext.get('idOrganisme');
            document.template = this.getContentEditor();
            this.documentService.createDocument(SessionContext.get('idOrganisme'), document).subscribe(response => {
                this.toastr.success(
                    this.translate.instant('page.edition.gestion-templates.creation-reussie'),
                    this.translate.instant('page.edition.gestion-templates.nouveau-document'),
                    { timeOut: 10 * 1000 }
                );
                this.documentService
                    .getDocumentsByCategorie(this.selectedCategorie.id, SessionContext.get('idOrganisme'))
                    .subscribe(documents => (this.documents = documents));
                this.tinymce.setContent('');
            });
        }
    }

    addModelePersonnalise() {
        const modalRef = this.modalService.open(AddDocumentComponent, { size: 'lg', backdrop: 'static' });
        modalRef.result.then(result => {
            const document: Document = new Document();
            document.libelle = result;
            document.refCategorie = this.selectedDocument.refCategorie;
            document.isIndividuel = this.selectedDocument.isIndividuel;
            document.isPaysage = this.selectedDocument.isPaysage;
            document.isMailable = this.selectedDocument.isMailable;
            document.template = this.selectedDocument.template;
            document.idOrganisme = SessionContext.get('idOrganisme');
            this.documentService.createDocument(SessionContext.get('idOrganisme'), document).subscribe(response => {
                this.toastr.success(
                    this.translate.instant('page.edition.gestion-templates.creation-modele-personnalise-reussie'),
                    this.translate.instant(document.libelle),
                    { timeOut: 10 * 1000 }
                );
                this.documentService.getDocumentsByCategorie(this.selectedCategorie.id, SessionContext.get('idOrganisme')).subscribe(documents => {
                    this.documents = documents;
                    this.tinymce.setContent(document.template);
                    this.selectedDocument = this.documents.find(d => d.id === response.id);
                    this.disableEditor = !this.selectedDocument.idOrganisme;
                });
            });
        });
    }

    getContentEditor() {
        return this.tinymce.getContent();
    }

    changeDocument() {
        this.disableEditor = !this.selectedDocument.idOrganisme;
        if (this.firstLoad) {
            setTimeout(() => {
                this.tinymce.setContent(this.selectedDocument.template);
                this.firstLoad = false;
            }, 3000);
        } else {
            this.tinymce.setContent(this.selectedDocument.template);
        }
    }
}
